/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TenantHealthSesEmail
 */
export interface TenantHealthSesEmail {
    /**
     * 
     * @type {number}
     * @memberof TenantHealthSesEmail
     */
    sent_7d?: number;
    /**
     * 
     * @type {number}
     * @memberof TenantHealthSesEmail
     */
    sent_30d?: number;
    /**
     * 
     * @type {number}
     * @memberof TenantHealthSesEmail
     */
    bounced_hard_7d?: number;
    /**
     * 
     * @type {number}
     * @memberof TenantHealthSesEmail
     */
    bounced_hard_30d?: number;
    /**
     * 
     * @type {number}
     * @memberof TenantHealthSesEmail
     */
    bounced_soft_7d?: number;
    /**
     * 
     * @type {number}
     * @memberof TenantHealthSesEmail
     */
    bounced_soft_30d?: number;
    /**
     * 
     * @type {number}
     * @memberof TenantHealthSesEmail
     */
    bounced_complaint_7d?: number;
    /**
     * 
     * @type {number}
     * @memberof TenantHealthSesEmail
     */
    bounced_complaint_30d?: number;
    /**
     * 
     * @type {number}
     * @memberof TenantHealthSesEmail
     */
    skipped_suppressed_7d?: number;
    /**
     * 
     * @type {number}
     * @memberof TenantHealthSesEmail
     */
    skipped_suppressed_30d?: number;
}

/**
 * Check if a given object implements the TenantHealthSesEmail interface.
 */
export function instanceOfTenantHealthSesEmail(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function TenantHealthSesEmailFromJSON(json: any): TenantHealthSesEmail {
    return TenantHealthSesEmailFromJSONTyped(json, false);
}

export function TenantHealthSesEmailFromJSONTyped(json: any, ignoreDiscriminator: boolean): TenantHealthSesEmail {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'sent_7d': !exists(json, 'sent_7d') ? undefined : json['sent_7d'],
        'sent_30d': !exists(json, 'sent_30d') ? undefined : json['sent_30d'],
        'bounced_hard_7d': !exists(json, 'bounced_hard_7d') ? undefined : json['bounced_hard_7d'],
        'bounced_hard_30d': !exists(json, 'bounced_hard_30d') ? undefined : json['bounced_hard_30d'],
        'bounced_soft_7d': !exists(json, 'bounced_soft_7d') ? undefined : json['bounced_soft_7d'],
        'bounced_soft_30d': !exists(json, 'bounced_soft_30d') ? undefined : json['bounced_soft_30d'],
        'bounced_complaint_7d': !exists(json, 'bounced_complaint_7d') ? undefined : json['bounced_complaint_7d'],
        'bounced_complaint_30d': !exists(json, 'bounced_complaint_30d') ? undefined : json['bounced_complaint_30d'],
        'skipped_suppressed_7d': !exists(json, 'skipped_suppressed_7d') ? undefined : json['skipped_suppressed_7d'],
        'skipped_suppressed_30d': !exists(json, 'skipped_suppressed_30d') ? undefined : json['skipped_suppressed_30d'],
    };
}

export function TenantHealthSesEmailToJSON(value?: TenantHealthSesEmail | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'sent_7d': value.sent_7d,
        'sent_30d': value.sent_30d,
        'bounced_hard_7d': value.bounced_hard_7d,
        'bounced_hard_30d': value.bounced_hard_30d,
        'bounced_soft_7d': value.bounced_soft_7d,
        'bounced_soft_30d': value.bounced_soft_30d,
        'bounced_complaint_7d': value.bounced_complaint_7d,
        'bounced_complaint_30d': value.bounced_complaint_30d,
        'skipped_suppressed_7d': value.skipped_suppressed_7d,
        'skipped_suppressed_30d': value.skipped_suppressed_30d,
    };
}

